import { createSelector } from 'reselect';

const getLoading = state => state.loading;

const LoadingSelector = loadActionType => params =>
  createSelector(getLoading, loading => loading[`${loadActionType}${params ? `_${JSON.stringify(params)}` : ''}`]);

export default LoadingSelector;
